import { Component, computed, inject, output } from '@angular/core';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ProductsService } from '../../../../api/products/products.service';
import { Product } from '../../../../api/model';
import { priceParts, priceUnit } from '@shared/price';
import { PpcButton } from '@design-system/button/button';
import { PpcEyebrow } from '@design-system/eyebrow/eyebrow';
import { PpcHeading } from '@design-system/heading/heading';
import { PpcLead } from '@design-system/lead/lead';

@Component({
  selector: 'app-offerings',
  imports: [TranslatePipe, PpcButton, PpcEyebrow, PpcHeading, PpcLead],
  templateUrl: './offerings.html',
  styleUrl: './offerings.css',
})
export class OfferingsComponent {
  readonly joinClick = output<number>();

  private readonly api = inject(ProductsService);
  private readonly translate = inject(TranslateService);

  private readonly HIGHLIGHT_INDEX = 1;

  private readonly productsResource = rxResource<Product[], void>({
    stream: () => this.api.getProducts(),
    defaultValue: [],
  });

  protected readonly products = computed(() => this.productsResource.value());

  protected readonly titleLines = toSignal(this.translate.stream('offerings.title'), {
    initialValue: [] as string[],
  });

  protected pickPlan(product: Product) {
    this.joinClick.emit(product.id);
  }

  protected priceUnit(product: Product) {
    return priceUnit(product.durationDays);
  }

  protected priceWhole(product: Product): number {
    return priceParts(product.sellingPrice).whole;
  }

  protected priceDecimals(product: Product): string {
    return priceParts(product.sellingPrice).decimals;
  }

  protected isHighlighted(index: number): boolean {
    return index === this.HIGHLIGHT_INDEX;
  }

  protected actionVariant(index: number): 'primary' | 'inverse' {
    return this.isHighlighted(index) ? 'primary' : 'inverse';
  }
}
